module.exports = __webpack_public_path__ + "img/group.df7bcafb.png";